var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"image"},[_c('img',{staticClass:"maintenance",attrs:{"src":require("@/assets/images/cloud_maintenance.svg")}})])])
}]

export { render, staticRenderFns }